import { signal } from "@preact/signals-react";

const carregando = signal({
    open: false,
    text: 'Carregando'
});

export default carregando;